import * as React from "react";
import { List } from "../../generic/list/List";
import { OfferRewardListItem } from "./OfferRewardListItem";
export var OfferRewardList = function (_a) {
    var _b = _a.rewards, rewards = _b === void 0 ? [] : _b, emptyListReplacement = _a.emptyListReplacement, className = _a.className;
    if (rewards.length <= 0) {
        return React.createElement(React.Fragment, null, emptyListReplacement);
    }
    return (React.createElement(List, { items: rewards, renderItem: renderReward(className), className: "flex flex--stacked flex--guts" }));
};
var renderReward = function (className) { return function (reward) {
    return (React.createElement(OfferRewardListItem, { reward: reward, key: reward.id + "_" + reward.amount, className: className }));
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/components/OfferRewardList.tsx
// module id = 956
// module chunks = 3